import { useEffect, useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { scrollToId } from "@/App";

export const LOGO_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_5dfb1111-ca82-4a70-877b-a5becd929945/artifacts/53cbed8d0c375f7a_unnamed.webp";

const LINKS = [
  { label: "Services", id: "services" },
  { label: "Who We Help", id: "who-we-help" },
  { label: "Process", id: "process" },
  { label: "Results", id: "results" },
  { label: "FAQ", id: "faq" },
  { label: "Contact", id: "contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="nav-header"
      className={`sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b transition-all duration-300 ${
        scrolled ? "border-slate-200 shadow-[0_4px_24px_-12px_rgba(15,23,42,0.12)]" : "border-slate-100"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between gap-4">
        <button data-testid="nav-logo-badge" onClick={() => window.__lenis?.scrollTo(0, { duration: 1.2 })} className="flex items-center gap-2.5 shrink-0">
          <img src="/logo-mark.png" alt="SORTD logo" className="h-10 w-10 object-contain" />
          <span className="font-display font-extrabold text-lg tracking-[0.14em] text-slate-900">
            SORTED<span className="text-emerald-600">.</span>
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-slate-600 hover:text-emerald-600 transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <span className="text-xs font-semibold px-2.5 py-1 bg-slate-100 text-slate-700 rounded-md border border-slate-200">
            NZ | AU
          </span>
          <button
            data-testid="nav-book-call-btn"
            onClick={() => go("contact")}
            className="bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold px-5 py-2.5 rounded-lg shadow-sm shadow-emerald-600/20 transition-all hover:shadow-md"
          >
            Book a Strategy Call
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-slate-700 p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-100 px-6 py-5 flex flex-col gap-4 shadow-lg">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left text-sm font-medium text-slate-700 hover:text-emerald-600 transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-mobile-book-call-btn"
            onClick={() => go("contact")}
            className="mt-2 flex items-center justify-center gap-2 bg-emerald-600 text-white text-sm font-semibold rounded-lg px-5 py-3"
          >
            Book a Strategy Call <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      )}
    </header>
  );
}
